import { FETCH_ANOMALY_FAIL, FETCH_ANOMALY_SUCCESS, RESET_ANOMALY } from "../actionTypes/smartInsights";

export const setAnomalyAction = data => ({
  type: FETCH_ANOMALY_SUCCESS,
  payload: { data }
});

export const resetAnomalyAction = error => ({ type: RESET_ANOMALY });

export const setAnomalyFailAction = error => ({
  type: FETCH_ANOMALY_FAIL,
  payload: { error }
});
